import { createWebHistory, createRouter } from "vue-router"
import i18n from "@/i18n"
const routes = [
  {
    path: '/',
    redirect: () => {
      const saved = localStorage.getItem('lang')

      if (saved) return `/${saved}`

      const browserLang = navigator.language.startsWith('ar') ? 'ar' : 'en'

      return `/${browserLang}`
    }
  },
  {
    path: "/:locale(en|ar)?",
    name: "index",
    component: () => import('@/pages/index/index.vue'),
  },
  {
    path: '/:locale(en|ar)?/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/pages/NotFound.vue'),
  },
  {
    path: '/:locale(en|ar)/properties',
    component: () => import('@/pages/properties/index.vue'),
    meta: {
       breadcrumb: 'nav.properties'
    }
  },
  {
    path: '/:locale(en|ar)/properties/:slug',
    component: () => import('@/pages/properties/Details.vue'),
    name: 'property-detail',
    meta: {
      breadcrumb: (route) => route.params.slug
    }
  },
  {
    path: '/:locale(en|ar)/projects',
    component: () => import('@/pages/projects/index.vue'),
    meta: {
       breadcrumb: 'nav.projects'
    }
  },
  {
    path: '/:locale(en|ar)/projects/:slug',
    component: () => import('@/pages/projects/Details.vue'),
    name: 'project-detail',
    meta: {
      breadcrumb: (route) => route.params.slug
    }
  },
  {
    path: '/:locale(en|ar)/city/:slug',
    component: () => import('@/pages/city/Details.vue'),
    name: 'city-detail',
  },
  {
    path: '/:locale(en|ar)/services',
    component: () => import('@/pages/services/index.vue'),
    meta: {
       breadcrumb: 'nav.services'
    }
  },
  {
    path: '/:locale(en|ar)/services/:slug',
    component: () => import('@/pages/services/ServiceDetailPage.vue'),
    name: 'service-detail',
    meta: {
      breadcrumb: (route) => route.params.slug
    }
  },
  {
    path: '/:locale(en|ar)/blogs',
    component: () => import('@/pages/blogs/index.vue'),
    meta: {
       breadcrumb: 'nav.blogs'
    }
  },
  {
    path: '/:locale(en|ar)/blogs/:slug',
    component: () => import('@/pages/blogs/BlogDetailPage.vue'),
    name: 'blog-detail',
    meta: {
      breadcrumb: (route) => route.params.slug
    }
  },
  {
    path: '/:locale(en|ar)/:slug',
    component: () => import('@/pages/Page.vue'),
    name: 'page-detail',
    meta: {
      breadcrumb: (route) => route.params.slug
    }
  },
  {
    path: '/:locale(en|ar)/contact',
    component: () => import('@/pages/Contact.vue'),
    meta: {
       breadcrumb: 'nav.contact'
    }
  },
  {
    path: '/:locale(en|ar)/faq',
    component: () => import('@/pages/Faq.vue'),
    meta: {
       breadcrumb: 'nav.faqs'
    }
  },
  {
    path: '/:locale(en|ar)/result',
    name: 'search-results',
    component: () => import('@/pages/SearchResults.vue'),
    meta: {
      breadcrumb: 'nav.Search Results'
    }
  },
  {
    path: '/:locale(en|ar)/about',
    component: () => import('@/pages/About.vue'),
    meta: {
       breadcrumb: 'nav.about'
    }
  },
  {
    path: '/:locale(en|ar)/turkish-citizenship',
    component: () => import('@/pages/TurkishCitizenship.vue'),
    meta: {
       breadcrumb: 'nav.Turkish Citizenship'
    }
  },
  {
    path: '/:locale(en|ar)/turkey-blog/:slug',
    component: () => import('@/pages/turkey-blog/index.vue'),
    name: 'turkey-blog-detail',
    meta: {
      breadcrumb: (route) => route.params.slug
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return {
      top: 0,
      behavior: 'smooth'
    }
  }
})

router.beforeEach((to, from, next) => {
  const locale = to.params.locale || "en"

  i18n.global.locale.value = locale

  document.documentElement.setAttribute("lang", locale)
  document.documentElement.setAttribute("dir", locale === "ar" ? "rtl" : "ltr")

  localStorage.setItem("lang", locale)

  next()
})
export default router